function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  rx: 22,
  fill: "#44ADF9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M50 23C35.096 23 23 35.096 23 50C23 64.904 35.096 77 50 77C64.904 77 77 64.904 77 50C77 35.096 64.904 23 50 23ZM47.3 71.411C36.635 70.088 28.4 61.016 28.4 50C28.4 48.326 28.616 46.733 28.967 45.167L41.9 58.1V60.8C41.9 63.77 44.33 66.2 47.3 66.2V71.411ZM65.93 64.553C65.228 62.366 63.23 60.8 60.8 60.8H58.1V52.7C58.1 51.215 56.885 50 55.4 50H39.2V44.6H44.6C46.085 44.6 47.3 43.385 47.3 41.9V36.5H52.7C55.67 36.5 58.1 34.07 58.1 31.1V29.993C66.011 33.206 71.6 40.955 71.6 50C71.6 55.616 69.44 60.719 65.93 64.553Z",
  fill: "white"
});

function SvgIntl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntl);
export default __webpack_public_path__ + "static/media/intl.81fc9a57.svg";
export { ForwardRef as ReactComponent };